"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ykbUtils = require("ykb-utils");
var _reactDom = require("react-dom");
var _Tooltip = _interopRequireDefault(require("../../Tooltip"));
var _Button = _interopRequireDefault(require("../../Button"));
var _this = void 0;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function getErrorMessage(errors) {
  return errors.join('. ');
}
var TooltipContent = function TooltipContent(_ref) {
  var errors = _ref.errors,
    undo = _ref.undo,
    undoText = _ref.undoText;
  function onClickUndo(e) {
    e.preventDefault();
    undo();
  }
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, getErrorMessage(errors), ' ', /*#__PURE__*/_react.default.createElement(_Button.default, {
    tabIndex: "-1",
    link: "#",
    onClick: onClickUndo
  }, undoText));
};
var ValidationTooltip = function ValidationTooltip(_ref2) {
  var errors = _ref2.errors,
    children = _ref2.children,
    undo = _ref2.undo,
    undoText = _ref2.undoText,
    _ref2$placement = _ref2.placement,
    placement = _ref2$placement === void 0 ? 'bottom' : _ref2$placement;
  var node = null;
  (0, _react.useEffect)(function () {
    node = (0, _reactDom.findDOMNode)(_this);
  }, []);
  if (!errors || errors.length <= 0) {
    return children;
  }
  return /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    error: true,
    visible: true,
    defaultVisible: true,
    placement: placement,
    trigger: [],
    destroyTooltipOnHide: true,
    getTooltipContainer: function getTooltipContainer(trigger) {
      var _trigger$parentElemen, _trigger$parentElemen2, _trigger$parentElemen3, _trigger$parentElemen4, _trigger$parentElemen5;
      var tableContainer = trigger === null || trigger === void 0 ? void 0 : (_trigger$parentElemen = trigger.parentElement) === null || _trigger$parentElemen === void 0 ? void 0 : (_trigger$parentElemen2 = _trigger$parentElemen.parentElement) === null || _trigger$parentElemen2 === void 0 ? void 0 : (_trigger$parentElemen3 = _trigger$parentElemen2.parentElement) === null || _trigger$parentElemen3 === void 0 ? void 0 : (_trigger$parentElemen4 = _trigger$parentElemen3.parentElement) === null || _trigger$parentElemen4 === void 0 ? void 0 : (_trigger$parentElemen5 = _trigger$parentElemen4.parentElement) === null || _trigger$parentElemen5 === void 0 ? void 0 : _trigger$parentElemen5.parentElement;
      return tableContainer ? tableContainer : (0, _ykbUtils.containerChecker)(node);
    },
    overlay: /*#__PURE__*/_react.default.createElement(TooltipContent, {
      errors: errors,
      undo: undo,
      undoText: undoText
    })
  }, children);
};
var _default = exports.default = ValidationTooltip;